const MarqueeSpan = ({ middleText, emoji, middleColor }) => {
  return (
    <span className='align-middle leading-[40px] sm:leading-[50px] md:leading-[60px]'>
      hack<span className={middleColor}>{middleText}</span>agirl {emoji} &nbsp;
    </span>
  )
}

export default MarqueeSpan
